import React, { useState, useContext, useRef, useEffect } from 'react';
import { Container, Row, Col, Card, Modal, Button, Form } from 'react-bootstrap';
import classnames from 'classnames';
import { Carousel } from 'react-responsive-carousel';
import { Formik } from 'formik';
import { ModalContext } from '../../contexts/modal';
import { SettingContext } from '../../contexts/settings';
import NavBar from '../../components/NavBar';
import Footer from '../../components/Footer';
import MyCard from '../../components/MyCard';
import Forms from './Forms';
import cardImg from '../../assets/images/invoice-3739354_640.jpg';
import necheImg from '../../assets/images/vegetables-140917_640.jpg';
import individualImg from '../../assets/images/invoice-3739354_640.jpg';
import buyerCompanyImg from '../../assets/images/pexels-pixabay-273209.jpg';
import businessesImg from '../../assets/images/pexels-artem-beliaikin-929245.jpg';
import sellerCompanyImg from '../../assets/images/pexels-rodnae-productions-7841832.jpg';
import sellerImg from '../../assets/images/sellers-1.png';
import buyerImg from '../../assets/images/buyer-1.png';
import affiliateImg from '../../assets/images/affiliate.png';
import bgVideoMP4 from '../../assets/videos/video.mp4';
// import bgVideoMP4 from '../../assets/videos/inovation.mp4';
import bgVideoWebM from '../../assets/videos/video.webm';
import users from '../../constants/users';
import business from '../../constants/business';
import { sliderImages } from '../../assets';

const MyCarousel = () => {
    return (
        <Carousel
            className="my-carousel"
            showArrows={false}
            showStatus={false}
            showIndicators={false}
            showThumbs={false}
            interval={3000}
            infiniteLoop={true}
            autoPlay={true}

        >
            <div>
                <img src={sliderImages['Restaurant.jpg'].default} />
                <p className="legend">Restaurants</p>
            </div>
            <div>
                <img src={sliderImages['Hotel.jpg'].default} />
                <p className="legend">Hotels</p>
            </div>
            <div>
                <img src={sliderImages['Clothes - Girls.jpg'].default} />
                <p className="legend">Clothing and Fashion</p>
            </div>
            <div>
                <img src={sliderImages['Pharmacy-2.jpg'].default} />
                <p className="legend">Pharmacy</p>
            </div>
            <div>
                <img src={sliderImages['Grocery.jpg'].default} />
                <p className="legend">Grocery shop</p>
            </div>
            <div>
                <img src={sliderImages['Electronics.jpg'].default} />
                <p className="legend">Electronics and phones</p>
            </div>
            <div>
                <img src={sliderImages['Books store.jpg'].default} />
                <p className="legend">Book store</p>
            </div>
            <div>
                <img src={sliderImages['Auto spares.jpg'].default} />
                <p className="legend">Automobiles</p>
            </div>
            <div>
                <img src={sliderImages['Home improvements.jpg'].default} />
                <p className="legend">Construction and home improvement material</p>
            </div>
            <div>
                <img src={sliderImages['Make up.jpg'].default} />
                <p className="legend">Cosmetics and beauty</p>
            </div>
            <div>
                <img src={sliderImages['baby products.2.jpg'].default} />
                <p className="legend">Child care products</p>
            </div>
            <div>
                <img src={sliderImages['Pharmacy.jpg'].default} />
                <p className="legend">Health care institutes</p>
            </div>
            <div>
                <img src={sliderImages['truck-1030846_640.jpg'].default} />
                <p className="legend">Transportation</p>
            </div>
            <div>
                <img src={sliderImages['architecture-5999913_640.jpg'].default} />
                <p className="legend">Real estate</p>
            </div>
        </Carousel>
    )
}

const HomePage = () => {
    const { regModal, handleModalClose, onRegisterClick } = useContext(ModalContext);
    const { siteSettings } = useContext(SettingContext);
    const refBuyerSeller = useRef(null);
    const videoRef = useRef();
    const viewScrollHandle = () => refBuyerSeller.current.scrollIntoView({ behavior: "smooth", block: "start" });
    const [sliderVideo, setSliderVideo] = useState('');

    useEffect(() => {
        const dataVideo = siteSettings.find(s => s.settingName === 'SLIDER_VIDEO')?.settingValue;

        if (videoRef.current) {
            videoRef.current.load();
        }

        setSliderVideo(dataVideo);
    }, [siteSettings, sliderVideo]);

    return (
        <>
            {/* <NavBar regModal={regModal} onRegisterClick={onRegisterClick} /> */}
            <div className="header-container">
                <header className="header">
                    <div className="header__content align-items-end">
                        <div>
                            <Card className="section-buysell__card shadow" onClick={viewScrollHandle}>
                                <img className="section-buysell__img" src={buyerImg} alt="card" />
                                <div className="section-buysell__content">
                                    <h4>Buyers</h4>
                                    {/* <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Expedita vero aliquam</p> */}
                                </div>
                            </Card>
                        </div>

                        <div className="header__text-box">
                            {/* <h1>Become a member</h1>
                            <h2>Life time free membership for early joiners</h2>
                            <h4>Pioneer and active members will get profit share <br /> of the company in addition to the regular benefit.</h4>
                            <h4 className="mb-3"><u>Lucky draw for early joiners</u></h4> */}
                            <h2>Become a member</h2>
                            <h4>Life time free membership for early joiners</h4>
                            <h4>Pioneer and active members will get profit share <br /> of the company in addition to the regular benefit.</h4>

                            <Card className="section-buysell__card shadow" onClick={() => onRegisterClick(users.AFFILIATE.key)}>
                                <img className="section-buysell__img" src={affiliateImg} alt="card" />
                                <div className="section-buysell__content">
                                    <h4>Affiliates/Influencers</h4>
                                    {/* <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Expedita vero aliquam</p> */}
                                </div>
                            </Card>
                        </div>

                        <div>
                            <Card className="section-buysell__card shadow" onClick={viewScrollHandle}>
                                <img className="section-buysell__img" src={sellerImg} alt="card" />
                                <div className="section-buysell__content">
                                    <h4>Sellers</h4>
                                    {/* <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Expedita vero aliquam</p> */}
                                </div>
                            </Card>
                        </div>
                    </div>
                </header>
            </div>

            <main>
                <section className="section-roles">
                    <Row>
                        <Col sm={12} md={4}>
                            <Card className="section-buysell__card shadow" onClick={viewScrollHandle}>
                                <img className="section-buysell__img" src={buyerImg} alt="card" />
                                <div className="section-buysell__content">
                                    <h4>Buyers</h4>
                                    {/* <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Expedita vero aliquam</p> */}
                                </div>
                            </Card>
                        </Col>

                        <Col sm={12} md={4}>
                            <Card className="section-buysell__card shadow" onClick={() => onRegisterClick(users.AFFILIATE.key)}>
                                <img className="section-buysell__img" src={affiliateImg} alt="card" />
                                <div className="section-buysell__content">
                                    <h4>Affiliates/Influencers</h4>
                                    {/* <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Expedita vero aliquam</p> */}
                                </div>
                            </Card>
                        </Col>

                        <Col sm={12} md={4}>
                            <Card className="section-buysell__card shadow" onClick={viewScrollHandle}>
                                <img className="section-buysell__img" src={sellerImg} alt="card" />
                                <div className="section-buysell__content">
                                    <h4>Sellers</h4>
                                    {/* <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Expedita vero aliquam</p> */}
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </section>

                <section className="section-buysell">
                    <Row>
                        <Col md={6}>
                            <div className="section-buysell__carousel">
                                <MyCarousel />
                            </div>
                        </Col>

                        <Col md={6}>
                            <section className="section-comingsoon">
                                <div className="bg-video">
                                    <video ref={videoRef} className="bg-video__content" autoPlay loop controls>
                                        <source src={sliderVideo} type="video/mp4" />
                                        {/* <source src={bgVideoWebM} type="video/webm" /> */}
                                        Your browser is not supported!
                                    </video>
                                </div>
                            </section>
                        </Col>
                    </Row>
                </section>

                <section className="section-cta" ref={refBuyerSeller}>
                    <Row>
                        <Col>
                            <h2 className="heading-section mb-6">Buyers</h2>
                        </Col>

                        <Col>
                            <h2 className="heading-section mb-6">Sellers</h2>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={3} sm={12}>
                            <MyCard
                                onButtonClick={() => onRegisterClick(users.BUYER_INDIVIDUAL.key)}
                                img={individualImg}
                                title="Individual Buyers"
                                desc="Household customers who want to get benefit from day to day shopping"
                                backTile="Individual Buyers"
                                variant="primary"
                                centered
                            />
                        </Col>

                        <Col md={3} sm={12}>
                            <MyCard
                                onButtonClick={() => onRegisterClick(users.BUYER_CORPORATE_COMPANIES.key)}
                                img={buyerCompanyImg}
                                title="Corporate Buyers"
                                desc="Willing to contribute in the society through charity program or to get in their own benefit"
                                backTile="Corporate Buyers"
                                variant="secondary"
                                centered
                            />
                        </Col>

                        <Col md={3} sm={12}>
                            <MyCard
                                onButtonClick={() => onRegisterClick(users.SELLER_BUSINESSES.key)}
                                img={businessesImg}
                                title="Small &amp; Medium businesses"
                                desc="Sole business owners / shops who want to boost and multiply the sales"
                                backTile="Small &amp; Medium businesses"
                                variant="tertiary"
                                centered
                            />
                        </Col>

                        <Col md={3} sm={12}>
                            <MyCard
                                onButtonClick={() => onRegisterClick(users.SELLER_CORPORATE_COMPANIES.key)}
                                img={sellerCompanyImg}
                                title="Corporate Sellers"
                                desc="Large scale business who are willing to boost their sales at gross root level"
                                backTile="Corporate Sellers"
                                variant="quaternary"
                                centered
                            />
                        </Col>
                    </Row>
                </section>
            </main>

            {/* <Footer /> */}
            {/* 
            <Modal
                show={regModal ? true : false}
                onHide={handleModalClose}
                centered
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Register as {regModal?.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Forms type={regModal?.key} id="registerForm" onFormSubmit={(values) => console.log(values)} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalClose}>
                        Close
                    </Button>
                    <Button className="button" type="submit" form="registerForm">
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal> */}
        </>
    );
}

export default HomePage;